module.exports = __webpack_public_path__ + "media/images/guideline/E03-9d0b208bb51f17b1da2891c0a013262a.jpg";